export default __webpack_public_path__ + "static/media/Harness of the Swift Talon.48433bc8.jpg";